import { configureStore, combineReducers } from "@reduxjs/toolkit"
import type { UnknownAction } from "@reduxjs/toolkit"
import authReducer, { logoutCurrentUser } from "../modules/auth/store/authSlice"
import organizationReducer from "../modules/organizations/store/organizationSlice"
import vacancyReducer from "../modules/recruitment/vacancies/store/vacancySlice"
import employeeReducer from "../modules/onboarding/employee/store/employeeSlice"
import employeeDetailsReducer from "../modules/employee/employee/store/employeeDetailsSlice"
import workflowsReducer from "../modules/onboarding/workflows/store/workflowSlice"
import liveWorkflowsReducer from "../modules/onboarding/workflows/store/liveWorkflowSlice"
import offboardingReducer from "../modules/offboarding/store/offboardingSlice"
import employeeOffboardingReducer from "../modules/offboarding/store/employeeOffboardingSlice"
import m365ConnectorReducer from "../modules/profile/store/m365ConnectorSlice"
import sage300ConnectorReducer from "../modules/profile/store/sage300ConnectorSlice"
import careers24ConnectorReducer from "../modules/profile/store/careers24ConnectorSlice"
import sageVipConnectorReducer from "@/modules/profile/store/sageVipConnectorSlice"
import userReducer from "../modules/users/store/userSlice"

const appReducer = combineReducers({
  auth: authReducer,
  organizations: organizationReducer,
  vacancies: vacancyReducer,
  employees: employeeReducer,
  employeeDetails: employeeDetailsReducer,
  workflows: workflowsReducer,
  liveWorkflows: liveWorkflowsReducer,
  offboarding: offboardingReducer,
  employeeOffboarding: employeeOffboardingReducer,
  m365Connector: m365ConnectorReducer,
  sage300Connector: sage300ConnectorReducer,
  careers24Connector: careers24ConnectorReducer,
  sageVipConnector: sageVipConnectorReducer,
  users: userReducer,
})

type AppState = ReturnType<typeof appReducer>

const rootReducer = (state: AppState | undefined, action: UnknownAction) => {
  if (action.type === logoutCurrentUser.fulfilled.type || action.type === "auth/logout") {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  devTools: import.meta.env.DEV,
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
